module.exports = __webpack_public_path__ + "img/744.32064619.jpg";